import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  FLAT_FORM_FIELD_NAME_FLOOR_NUMBER,
  FLAT_FORM_FLOOR_NUMBER_FIELD_MAX_LENGTH,
} from '../../FlatForm.constants'

function FloorNumberField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Flat.FloorNumberLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={FLAT_FORM_FLOOR_NUMBER_FIELD_MAX_LENGTH}
      name={FLAT_FORM_FIELD_NAME_FLOOR_NUMBER}
      placeholder={t('Flat.FloorNumberPlaceholderKey')}
    />
  )
}

export default FloorNumberField
